import { render, staticRenderFns } from "./PhonesIcon.vue?vue&type=template&id=452b6ca2&"
import script from "./PhonesIcon.vue?vue&type=script&lang=js&"
export * from "./PhonesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports